/**
 * Zoho Books Style Item / Product & Service Entity Model
 * Aligned with GST & Cloud Firestore schema
 */
export function createDefaultItem(data = {}) {
  return {
    itemName: data.itemName || data.name || "",
    itemType: data.itemType || "sales", // 'sales', 'purchase', 'goods', 'service'
    gstCode: data.gstCode || data.sku || "", // HSN or SAC code
    gstPercent: data.gstPercent !== undefined ? Number(data.gstPercent) : 18,
    basicPrice: data.basicPrice !== undefined ? Number(data.basicPrice) : Number(data.sellingPrice || data.price || 0),
    costPrice: Number(data.costPrice || 0),
    stock: Number(data.stock || 0),
    reorderLevel: Number(data.reorderLevel || 10),
    unit: data.unit || "pcs", // 'pcs', 'mtr', 'kg', 'box', 'nos', 'set'
    status: data.status || "active",
    companyIds: Array.isArray(data.companyIds) ? data.companyIds : []
  };
}

/**
 * An item belongs to a company when ticked for it.
 * Old records not yet assigned count for every company.
 */
export function itemInCompany(item, companyId) {
  if (!item) return false;
  const ids = item.companyIds;
  if (!Array.isArray(ids) || ids.length === 0) return true;
  return !companyId || ids.includes(companyId);
}

export const GST_RATES = [0, 5, 12, 18, 28];

export const ITEM_UNITS = [
  { id: "pcs", label: "Pieces (pcs)" },
  { id: "mtr", label: "Meters (mtr)" },
  { id: "kg", label: "Kilograms (kg)" },
  { id: "box", label: "Boxes (box)" },
  { id: "nos", label: "Numbers (nos)" },
  { id: "set", label: "Sets (set)" },
  { id: "roll", label: "Rolls (roll)" }
];
